import { Injectable } from '@angular/core';
import { MaskApplierService } from 'ngx-mask';
import { phoneMask, phoneMaskNoBRPrefix } from '@shared/scripts/general';

@Injectable({
  providedIn: 'root',
})
export class PhoneHelperService {
  constructor(private readonly maskService: MaskApplierService) {}

  mask(phone: string) {
    return phoneMask(this.maskService, phone);
  }

  maskNoBRPrefix(phone: string): string {
    return phoneMaskNoBRPrefix(this.maskService, phone);
  }

  // Checamos com base na quantidade de caracteres
  // 5547996101234 = movel
  // 551124081920 = fixo
  checkIfIsMobilePhone(phoneNumber: string): boolean {
    return phoneNumber.length == 13;
  }

  // Tiramos caracteres estranhos, o 0 do inicio e adicionamos o 55
  formatPhone(phone: string): string | null {
    let formattedPhone = phone.replace(/\D/g, '');

    if (formattedPhone.startsWith('0')) {
      formattedPhone = formattedPhone.substring(1);
    }

    if (!formattedPhone.startsWith('55')) {
      formattedPhone = '55' + formattedPhone;
    }

    return /^\d{12,13}$/.test(formattedPhone) ? formattedPhone : null;
  }
}
